import axios from 'axios'

export default {
  fetch (method, url, data) {
    return new Promise(function (resolve, reject) {
      if (method === 'get') {
        resolve(axios.get(url, data))
      } else if (method === 'post') {
        resolve(axios.post(url, data))
      }
    })
  }
  // fetches (method, url, data, store, next) {
  //   return new Promise(function (resolve, reject) {
  //     axios.post(url, data).then(res => {
  //       if (localStorage.getItem('logoimgurl')) {
  //         store.state.logoimgurl = decodeURIComponent(localStorage.getItem('logoimgurl'))
  //       } else {
  //         localStorage.setItem('logoimgurl', res.data.logoimgurl);
  //       }
  //       if (localStorage.getItem('allreqdomain')) {
  //         store.state.allreqdomain = localStorage.getItem('allreqdomain')
  //       } else {
  //         localStorage.setItem('allreqdomain', res.data.allreqdomain);
  //       }
  //       resolve()
  //     }, error => {
  //       reject(error)
  //     })
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/apis/index.js